var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoPanorama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,19.1c-4.3,0-8.1,2.2-10.4,5.5C35.3,24.4,33.8,24,32,24c-1.7,0-3.5,0.3-4.9,0.6c-2.3-3.2-6.1-5.5-10.4-5.5 C9.7,19.1,3.8,25,3.8,32s5.8,12.9,12.9,12.9S29.6,39,29.6,32c0-0.3,0-0.6,0-1.1c0.8-0.2,1.7-0.2,2.4-0.2c0.7,0,1.7,0.2,2.4,0.2 c0,0.3,0,0.6,0,1.1c0,7,5.8,12.9,12.9,12.9S60.2,39,60.2,32S54.3,19.1,47.3,19.1z M16.7,42.7C10.8,42.7,6,37.9,6,32 s4.8-10.7,10.7-10.7S27.4,26.1,27.4,32S22.6,42.7,16.7,42.7z M32,28.7c-0.9,0-2,0.2-2.9,0.3c-0.2-0.8-0.4-1.5-0.8-2.3 c1.1-0.2,2.4-0.3,3.7-0.3c1.3,0,2.6,0.2,3.7,0.3c-0.3,0.8-0.6,1.5-0.9,2.3C34,28.8,32.9,28.7,32,28.7z M47.3,42.7 c-5.9,0-10.7-4.8-10.7-10.7s4.8-10.7,10.7-10.7S58,26.1,58,32S53.2,42.7,47.3,42.7z M16.7,40.7c-0.6,0-1.1-0.4-1.1-1.1 s0.4-1.1,1.1-1.1c3.7,0,6.6-2.9,6.6-6.6c0-0.6,0.5-1.1,1.1-1.1s1.1,0.4,1.1,1.1C25.4,36.9,21.6,40.7,16.7,40.7z M47.3,40.7 c-0.6,0-1.1-0.4-1.1-1.1s0.5-1.1,1.1-1.1c3.7,0,6.6-2.9,6.6-6.6c0-0.6,0.5-1.1,1.1-1.1S56,31.4,56,32C56,36.9,52.2,40.7,47.3,40.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPanorama);
export default __webpack_public_path__ + "static/media/picto-panorama.c9e8fd5114cb29a68030bccbfd84e719.svg";
export { ForwardRef as ReactComponent };